"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lcHttp = _interopRequireDefault(require("lc-http"));
var _default = function _default(options) {
  var fetchOfferUrl = options.fetchOfferUrl,
    body = options.body;
  return _lcHttp.default.post(fetchOfferUrl, {
    data: body
  });
};
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions/dist/pf-revisions.scss');